/**
 * Theme mode context for sharing theme state across the app.
 * Supports light, dark, and retro (unlockable Easter egg) modes.
 */

import { createContext, useContext } from 'react';
import type { PaletteMode } from '@mui/material';

export type AppThemeMode = PaletteMode | 'retro';

interface ThemeContextValue {
  mode: PaletteMode;
  appMode: AppThemeMode;
  toggleMode: () => void;
  setMode: (mode: PaletteMode) => void;
  setRetro: (on: boolean) => void;
  isRetro: boolean;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useThemeContext() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within ThemeContext.Provider');
  }
  return context;
}
